const companiesType = [
	{
		path: '/companies/companies-type/list',
		name: 'companies-type-list',
		component: () => import('@/views/companies/companies-type/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/companies/list',
		name: 'companies-list',
		component: () => import('@/views/companies/companies/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/companies/new',
		name: 'companies-create',
		component: () => import('@/views/companies/companies/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/companies/edit/:id',
		name: 'companies-edit',
		component: () => import(/* webpackChunkName: "NetworkCompaniesEdit" */ '@/views/companies/companies/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
]

export default companiesType
